import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import Divider from '../../../../../../common/divider/divider';
import { UserDetailsProp } from '../interfaces';
import RoleSelector from './roleSelector';
import DetailsList from '../../../../../../common/details-list';
import locales from '../locales';
import RoleDescription from './roleDescription';
import WithFormLayout from '../../../../../../common/with-form-layout';
import { mapToApiFormat } from '../dataTransformator';

type BusinessError = any;

interface Props {
  selectedUser: UserDetailsProp;
  handleCloseDialog: () => void;
  onSubmit: (props: any) => void;
  loading: boolean;
  error?: BusinessError | null;
}

const UserDetails = ({ selectedUser, handleCloseDialog, onSubmit, loading, error }: Props) => {
  const [selectedRole, setSelectedRole] = useState<string>(selectedUser.userData.role.name);
  const [mappedRoles] = useState<string[]>(selectedUser.roles.map(item => item.name));

  const valuesUnchanged = selectedUser.userData.role.name === selectedRole;

  const items = [
    { label: locales.updateUser.label.username, value: selectedUser.userData.name },
    { label: locales.updateUser.label.email, value: selectedUser.userData.emailAddress }
  ];

  useEffect(() => {}, [handleCloseDialog]);

  useEffect(() => {
    setSelectedRole(selectedUser.userData.role.name);
  }, [selectedUser]);

  const handleSelectUserRole = (e: React.SetStateAction<string>) => {
    setSelectedRole(e);
  };

  const handleCancel = () => {
    setSelectedRole('');
    handleCloseDialog();
  };

  const handleUpdate = () => {
    onSubmit(mapToApiFormat({ userId: selectedUser.userData.userId, roleId: selectedRole }));
  };

  return (
    <Box>
      <WithFormLayout
        formInfoText=""
        submitLabel="Update user role"
        secondaryLabel={valuesUnchanged ? 'Close' : 'Close without update'}
        disableSubmit={error?.severity ? true : valuesUnchanged}
        onSubmit={error?.severity ? handleCancel : handleUpdate}
        onSecondary={handleCancel}
        loading={loading}
        error={error}
      >
        <DetailsList items={items} />
        <Divider />
        <Grid container>
          <Grid item xs={12}>
            <RoleSelector
              selectedRole={selectedRole}
              handleSelectRole={handleSelectUserRole}
              possibleRoles={mappedRoles}
              handleBlur={() => {}}
            />
          </Grid>
          <Grid item xs={12} sx={{ pt: 1 }}>
            <Typography variant="body1">Role description</Typography>
            <RoleDescription selectedRole={selectedRole} possibleRoles={selectedUser.roles} />
          </Grid>
        </Grid>
      </WithFormLayout>
    </Box>
  );
};

export default UserDetails;
